/**
 * Registry keys and default timings of the built-in display gates (see ConcertAds#blockUntilDisplay
 * and `app.displayGates`).
 *
 * Reference the keys instead of repeating the string literals so a typo fails loudly as an undefined
 * import rather than silently arming or releasing a gate nobody waits on. Kept apart from DisplayGate,
 * which is a domain-agnostic primitive that knows nothing of what it gates. Custom gates (armed with
 * ConcertAds#blockUntilDisplay) have no default backstop; only the built-in gates below do.
 *
 * The values are also the public strings used in slot `exemptFromBlocking` lists and docs, so they are
 * part of the API and must not change.
 */
export const DisplayGateKeys = Object.freeze({
  // Opens when the designated first slot fires its request.
  FIRST_SLOT: 'firstSlot',
  // Opt-in gate: opens when the designated first slot's GAM response renders (or on its timeout).
  FIRST_SLOT_RESPONSE: 'firstSlotResponse',
});

// Both gates the designated first slot opens — it must be exempt from each, or it would wait on itself.
export const FIRST_SLOT_GATE_KEYS = Object.freeze([DisplayGateKeys.FIRST_SLOT, DisplayGateKeys.FIRST_SLOT_RESPONSE]);

// Backstop (ms) for the firstSlot gate when settings.firstSlotTimeout is unset, so the page never
// waits forever on a first slot that never requests. Its countdown starts at install. It governs the
// firstSlot gate only; the firstSlotResponse gate has its own timeout, below.
export const DEFAULT_FIRST_SLOT_TIMEOUT = 3000;

// Backstop (ms) for the firstSlotResponse gate when settings.firstSlotResponseTimeout is unset: the
// longest a slot flagged waitForFirstSlotResponse waits for GAM to answer the first slot, counted from
// the moment that slot REQUESTS. 2500 = the 2000ms bid timeout plus 500ms of padding.
export const DEFAULT_FIRST_SLOT_RESPONSE_TIMEOUT = 2500;
